import { render, staticRenderFns } from "./KucunTable.vue?vue&type=template&id=131b3d85&scoped=true&"
import script from "./KucunTable.vue?vue&type=script&lang=js&"
export * from "./KucunTable.vue?vue&type=script&lang=js&"
import style0 from "./KucunTable.vue?vue&type=style&index=0&id=131b3d85&scoped=true&lang=css&"
import style1 from "./KucunTable.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "131b3d85",
  null
  
)

export default component.exports